<template>
  <div class="tree-query col-xl-12 col-12 px-0 mb-0">
    <div v-for="(query, index) in rawQueries" :key="index">
      <div v-bind:style="{ marginLeft: query.subLevel*50 + 'px' }">
        <div class="dropdown and-or-condition" v-if="query.level != undefined">
          <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
            {{ query.operator }}
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" v-on:click="operatorCondition('AND',query.level,query.id)"
               href="javascript:void(0)">AND</a>
            <a class="dropdown-item" v-on:click="operatorCondition('OR',query.level,query.id)"
               href="javascript:void(0)">OR</a>
          </div>
        </div>

        <div v-if="!query.group">
          <div class="company-desc-value" v-if="!query.remove && query.level != undefined">
            <div v-on:click="automationEditState($event,query.level,query.id)">
              <p>{{ query.tableField }}&nbsp;{{ query.having }}</p>
              <span>{{ query.fieldConcatValue }}</span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </div>
            <a href="javascript:void(0)"><i class="fa fa-times" aria-hidden="true"
                                            v-on:click.stop.prevent="removeDiv(query.level,query.id)"></i></a>
          </div>
        </div>

        <div class="btn-group" v-if="query.level != undefined">
          <button class="btn btn-secondary apply-btn-color btn-sm"
                  v-on:click.stop.prevent="openAutomationModal(query.level)"> + Add
            Condition
          </button>
          <button class="btn btn-outline-primary btn-sm dropdown-toggle"
                  v-on:click.stop.prevent="addNewconditionGroup($event,query.level,query.id, query.subLevel+1)"></button>
        </div>
      </div>
      {{ query.order }}
    </div>
    <!-- <div v-for="(query, index) in FormatQuery(queries)" :key="index">
        <div class="dropdown and-or-condition" v-if="query.level != undefined">
          <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ query.operator }}
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" v-on:click="operatorCondition('AND',query.level,query.id)" href="javascript:void(0)">AND</a>
            <a class="dropdown-item" v-on:click="operatorCondition('OR',query.level,query.id)" href="javascript:void(0)">OR</a>
          </div>
        </div>

        <div v-if="!query.group">
            <div class="company-desc-value" v-if="!query.remove && query.level != undefined">
              <div v-on:click="automationEditState($event,query.level,query.id)">
                  <p>{{ query.tableField }}&nbsp;{{ query.having }}</p>
                  <span>{{ query.fieldConcatValue }}</span>
                  <i class="fa fa-caret-down" aria-hidden="true"></i>
              </div>
                <a href="javascript:void(0)"><i class="fa fa-times" aria-hidden="true" v-on:click.stop.prevent="removeDiv(query.level,query.id)"></i></a>
            </div>
        </div>

        <div class="btn-group" v-if="query.level != undefined">
              <button class="btn btn-secondary apply-btn-color btn-sm" v-on:click.stop.prevent="openAutomationModal(query.level)"> + Add Condition</button>
              <button class="btn btn-outline-primary btn-sm dropdown-toggle" v-on:click.stop.prevent="addNewconditionGroup($event,query.level,query.id, 1)"></button>
        </div>
    </div> -->

  </div>
</template>
<script>
export default {
  props: [
    'queries',
    'rawQueries',
    'level',
    'parentId',
    'operator',
    'tableField',
    'having',
    'fieldConcatValue',
    'id',
    'depth',
    'group',
    'remove',
  ],
  data() {
    return {
      dynamicHTML: ''
    }
  },
  // name: 'tree-query',
  created() {

  },
  computed: {
    indent() {
      return {transform: `translate(${this.depth * 50}px)`}
    }
  },
  methods: {
    openAutomationModal(level) {
      this.$emit('AutomationModal', level);
    },
    addNewconditionGroup(event, level, id, subLevel) {

      // let append_data = '<div class="btn-group" v-if="query.level != undefined">'+
      //       '<button class="btn btn-secondary apply-btn-color btn-sm"> + Add Condition</button>'+
      //       '<button v-on:click.stop.prevent="addNewconditionGroup($event,query.level,query.id, 1)" class="btn btn-outline-primary btn-sm dropdown-toggle"></button>'+
      //       '</div>';

      // var _template = Vue.compile(append_data);
      // console.log(_template);
      // $('.append-group').html(append_data);
      if (isNaN(subLevel)) {
        subLevel = 0;
      }

      this.$emit('addNewconditionGroup', event, level, id, subLevel);
    },
    operatorCondition(value, level, id) {
      this.$emit('operatorCondition', value, level, id);
    },
    removeDiv(level, id) {
      this.$emit('removeDiv', level, id);
    },
    automationEditState(event, level, id) {
      this.$emit('automationEditState', event, level, id);
    },
    FormatQuery(queries) {
      let me = this;
      // queries.forEach(function (query, key) {
      //   var _x = '';
      //   for(var i = 0; i < query.subLevel; i++) {
      //     _x += '-';
      //   }

      //   console.log(_x + query.tableField+" "+query.having+" "+query.value);
      //   if(query.queries != undefined) {
      //     me.FormatQuery(query.queries);
      //   }
      //   // console.log(query);
      // });

      return queries;
    }
  }
}
</script>